export default __webpack_public_path__ + "static/San-Francisco-d8f0fad0def6e73fe6b5afbd83478718.webp";